<div class="confirm-dialog">
  <div class="title">{{ message }}</div>
  <div class="actions">
    <a href="javascript:;" class="btn btn-link" (click)="close(true)">{{ localization | mtgTranslate: 'yes' }}</a>
    <a href="javascript:;" class="btn btn-link text-muted" (click)="close(false)">{{ localization | mtgTranslate: 'no' }}</a>
  </div>
</div>
